export default __webpack_public_path__ + "static/media/website_video1.37ac62f2.mp4";